import { render, staticRenderFns } from "./SanifairLogsTable.vue?vue&type=template&id=5d78b4b3"
import script from "./SanifairLogsTable.vue?vue&type=script&lang=ts"
export * from "./SanifairLogsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports